import React, {useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import Navigation from "./navigation";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles({
    scrollable: {
        ['@media (max-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 100*vh-68,
            display: 'flex',
            flexDirection: 'column',
        },
        ['@media (min-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 720-68,
            display: 'flex',
            flexDirection: 'column',
        },
    },
    main: {
        position: 'relative',
        background: 'linear-gradient(180.02deg, #FF8A00 0.02%, #58AF56 121.49%, #58AF56 134.83%)',
        minHeight: 'inherit',
        height: 'inherit',
        width: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'inherit',
        borderRadius: 'inherit',
        margin: 0,
        top: 0,
        left: 0,
    },
    textHeader: {
        fontStyle: 'normal',
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '30px',
        textAlign: 'center',
        margin: '40px',
        color: '#000000',
    },
    instructionRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ['@media (max-width: 640px)']: {
            justifyContent: 'center',
        },
        ['@media (min-width: 640px)']: {
            marginLeft: '20px',
            justifyContent: 'left',
        },
    },
    textInstruction: {
        fontStyle: 'normal',
        fontSize: '18px',
        lineHeight: '24px',
        textAlign: 'left',
        maxWidth: '80%',
        color: '#000000',
    },
    divider: {
        align: 'center',
        background: '#000000',
        border: "3px solid #000000",
        boxSizing: "border-box",
        borderRadius: '3px',
        marginBottom: '20px',
        marginLeft: '30%',
        marginRight: '30%',
        width: '40%',
    },
    lastElement: {
        paddingBottom: '15%',
    },
    numberCorrect: {
        left: '50%',
        display: "flex",
        background: "green",
        borderRadius: "1em",
        fontWeight: "bold",
        height: "2em",
        width: "2em",
        textAlign: "center",
        justifyContent: 'center',
        alignItems: 'center',
        margin: "1em",
        verticalAlign: "middle",
    },
    numberIncorrect: {
        left: '50%',
        display: "flex",
        background: "orange",
        borderRadius: "1em",
        fontWeight: "bold",
        height: "2em",
        width: "2em",
        textAlign: "center",
        justifyContent: 'center',
        alignItems: 'center',
        margin: "1em",
        verticalAlign: "middle",
    },
    arrowButton: {
        '& svg': {
          fontSize: '48px',
          color: 'black',
        },
    }
});

export default function Results(props) {
    const { currentAnswers, correctAnswers, totalQuestions } = props;
    const classes = useStyles();
    const [displayAnswers, setDisplayAnswers] = useState(false);
    let correctCount = 0;
    Object.keys(currentAnswers).forEach((key) => {
        correctCount += currentAnswers[key] === correctAnswers[key].option;
    })
    let incorrectCount = totalQuestions - correctCount;
    return (
        <main className={classes.main}>
            <div className={classes.scrollable}>
                <h2 className={classes.textHeader}>Twój wynik</h2>
                <div className={classes.divider}/>
                <div className={classes.instructionRow} style={{justifyContent: 'center', marginLeft: 0}}>
                    <div className={classes.numberCorrect}><div>{correctCount}</div></div>
                    <p style={{maxWidth: '40%'}} className={classes.textInstruction}>DOBRYCH ODPOWIEDZI</p>
                </div>
                <div className={classes.instructionRow} style={{justifyContent: 'center', marginLeft: 0}}>
                    <div className={classes.numberIncorrect}>{incorrectCount}</div>
                    <p style={{maxWidth: '40%'}} className={classes.textInstruction}>ZŁYCH ODPOWIEDZI</p>
                </div>
                <div>
                    <h2 className={classes.textHeader}>Zobacz poprawne odpowiedzi</h2>
                    <div className={classes.divider}/>
                    {displayAnswers ?
                      <IconButton className={classes.arrowButton}>
                        <KeyboardArrowUp onClick={() => setDisplayAnswers(false)}/>
                      </IconButton> :
                      <IconButton className={classes.arrowButton}>
                        <KeyboardArrowDown onClick={() => setDisplayAnswers(true)}/>
                      </IconButton>}
                </div>
                {displayAnswers && Object.entries(correctAnswers).map(([questionId, answer]) => {
                    return (<div className={classes.instructionRow}>
                        <div className={classes.numberCorrect}><div>{questionId}</div></div>
                        <p className={classes.textInstruction}>{answer.displayAnswer}</p>
                    </div>)
                })}
                <div style={{flex: '1 1 auto'}}/>
            </div>
            <Navigation buttonPath={'/quiz-klimatyczny/reward'} buttonText={'nagroda :)'} isGreen={true}/>
        </main>
    );
}